import { Drawer as MantineDrawer } from "@mantine/core";
import styles from "../drawer.module.scss";
import type { CustomDrawerRootFactory, IProps } from "./drawer-root.types";
import { componentWrapper } from "../../../utilities";

const DrawerRoot = componentWrapper<CustomDrawerRootFactory, IProps>("DrawerRoot", ({ ...otherProps }, ref) => {
    return (
        <MantineDrawer.Root
            ref={ref}
            classNames={{
                root: styles["root"],
                overlay: styles["overlay"],
                content: styles["content"],
                header: styles["header"],
                body: styles["body"],
                title: styles["title"],
                close: styles["close"],
                inner: styles["inner"],
            }}
            {...otherProps}
        />
    );
});

export { DrawerRoot };
